<template>
  <div class="page-card">
    <div class="page-card__head">
      <div>
        <div class="page-card__title">健康观察</div>
        <div class="page-card__desc">查看健康记录和异常状态，后续可接预警、体重趋势和图片留档。</div>
      </div>
      <button class="action-button">新增记录</button>
    </div>

    <div class="placeholder-grid">
      <div class="placeholder-card">观察记录</div>
      <div class="placeholder-card">异常标签</div>
      <div class="placeholder-card">健康趋势</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HealthRecordView"
}
</script>
